const descriptionRules = [
  {
    feedback: 'Description is required',
    test(value) {
      return !!value;
    },
  },
  {
    feedback: 'Maximum length of 256 characters',
    test(value) {
      return value.length <= 256;
    },
  },
];

export default descriptionRules;
